export const SAVE_POSTS_LIST = 'SAVE_POSTS_LIST';
export const SAVE_PHOTOS_LIST = 'SAVE_PHOTOS_LIST';
export const SAVE_ALBULMS_LIST = 'SAVE_ALBULMS_LIST';
export const SAVE_ALBUMDETAIL = 'SAVE_ALBUMDETAIL';
export const RESET_ALBUMDETAIL = 'RESET_ALBUMDETAIL';
export const SAVE_USERS_LIST = 'SAVE_USERS_LIST';
export const SAVE_SHOWSPINNER = 'SAVE_SHOWSPINNER';
export const RESET_SHOWSPINNER = 'RESET_SHOWSPINNER';
export const SAVE_POSTDETAIL = 'SAVE_POSTDETAIL';
export const RESET_POSTDETAIL = 'RESET_POSTDETAIL';
export const SAVE_USERS_DETAIL = 'SAVE_USERS_DETAIL';
export const SAVE_USERS_TODOS = 'SAVE_USERS_TODOS';
export const SAVE_USERS_POSTS = 'SAVE_USERS_POSTS';
export const SAVE_USERS_ABLUMS = 'SAVE_USERS_ABLUMS';
export const RESET_USER_DETAIL = 'RESET_USER_DETAIL';
export const RESET_USER_DETAIL_CHILDREN = 'RESET_USER_DETAIL_CHILDREN';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js